import { render, staticRenderFns } from "./revokeTip.vue?vue&type=template&id=ee44e450&scoped=true"
import script from "./revokeTip.vue?vue&type=script&lang=js"
export * from "./revokeTip.vue?vue&type=script&lang=js"
import style0 from "./revokeTip.vue?vue&type=style&index=0&id=ee44e450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee44e450",
  null
  
)

export default component.exports